import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumbs from "../components/Breadcrumbs";
import AppointmentForm from "../components/AppointmentForm";
import locationIcon from "../assets/icons/locationIcon.svg";
import mailIcon from "../assets/icons/MailIcon.svg";
import openHrs from "../assets/icons/openingHrs.svg";
import callUS from "../assets/icons/callUs.svg";
import facebook from "../assets/icons/footer-fb.svg";
import emergencyContact from "../assets/images/emergencyContact.png";
import phoneIcon from "../assets/images/phoneIcon.svg";
import { useNavigate } from "react-router-dom";

// Social Media Icon
const SocialMediaIcon = ({ src, alt }) => (
  <div className="contactUs_socialIcon">
    <img src={src} alt={alt} className="contactUs_iconImg" />
  </div>
);

// Contact Info Icon
const ContactInfo = ({ src, alt }) => (
  <div className="contactUs_contactIcon">
    <img src={src} alt={alt} className="contactUs_iconImg" />
  </div>
);

export default function ContactUs() {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState("contact");

  const breadcrumbItems = [
    {
      label: "Home",
      active: hovered === "home",
      onMouseEnter: () => setHovered("home"),
      onMouseLeave: () => setHovered(null),
    },
    {
      label: "Contact Us",
      active: hovered === "contact" || hovered === null,
      onMouseEnter: () => setHovered("contact"),
      onMouseLeave: () => setHovered("contact"),
    },
  ];

  return (
    <div className="contactUs_page">
      <Header />

      {/* HERO SECTION */}
      <div className="contactUs_hero">
        <div className="contactUs_breadcrumbWrapper">
          <Breadcrumbs items={breadcrumbItems} />
        </div>

        <div className="contactUs_heroBg" />

        <div className="contactUs_heroText">
          <p className="contactUs_heroSubtitle">Contact Us</p>
          <h1 className="contactUs_heroTitle">Contact Verimed</h1>
          <p className="contactUs_heroDesc">
            We’re here to help — wherever you are
          </p>
        </div>
      </div>

      {/* CONTACT DETAILS */}
      <div className="contactUs_details">
        <h2 className="contactUs_detailsTitle">Get close with us</h2>
        <p className="contactUs_detailsSubtitle">
          At VeriMED, communication is at the heart of our care...
        </p>

        <div className="contactUs_officeWrapper">
          {/* CAMEROON OFFICE */}
          <div className="contactUs_officeBlock">
            <h3 className="contactUs_officeTitle">Cameroon Office</h3>

            <div className="contactUs_officeGrid">
              <div className="contactUs_officeRow">
                <ContactInfo src={locationIcon} alt="Location" />
                <div>
                  <p className="contactUs_infoLabel">Location</p>
                  <p className="contactUs_infoValue">Buea Cameroon</p>
                </div>
              </div>

              <div className="contactUs_officeRow">
                <ContactInfo src={openHrs} alt="Hours" />
                <div>
                  <p className="contactUs_infoLabel">Office Hours</p>
                  <p className="contactUs_infoValue">24*7 On Call</p>
                </div>
              </div>

              <div className="contactUs_officeRow">
                <ContactInfo src={callUS} alt="Call" />
                <div>
                  <p className="contactUs_infoLabel">Contact</p>
                  <p className="contactUs_infoValue">+237 6-50-41-99-86</p>
                </div>
              </div>

              <div className="contactUs_officeRow">
                <ContactInfo src={mailIcon} alt="Email" />
                <div>
                  <p className="contactUs_infoLabel">Email</p>
                  <p className="contactUs_infoValue">info@verimed.care</p>
                </div>
              </div>
            </div>
          </div>

          {/* NORTH AMERICA OFFICE */}
          <div className="contactUs_officeBlock">
            <h3 className="contactUs_officeTitle">North America Contact</h3>

            <div className="contactUs_officeGrid">
              <div className="contactUs_officeRow">
                <ContactInfo src={callUS} alt="Call" />
                <div>
                  <p className="contactUs_infoLabel">Contact</p>
                  <p className="contactUs_infoValue">+1 551-502-0063</p>
                </div>
              </div>

              <div className="contactUs_officeRow">
                <ContactInfo src={mailIcon} alt="Email" />
                <div>
                  <p className="contactUs_infoLabel">Email</p>
                  <p className="contactUs_infoValue">info@verimed.care</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SOCIAL LINKS */}
        <div className="contactUs_socialWrapper">
          <div className="contactUs_socialRow">
            <p className="contactUs_socialLabel">Social Media:</p>
            <SocialMediaIcon src={facebook} alt="Facebook" />
          </div>
        </div>
      </div>

      {/* MAP SECTION */}
      <div className="contactUs_mapSection">
        <h2 className="contactUs_mapTitle">Get Location</h2>

        <div className="contactUs_mapContainer">
          <iframe
            title="Verimed Location"
            src="https://www.google.com/maps/embed?...yourmap..."
            width="90%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>

      <AppointmentForm />

      {/* EMERGENCY SECTION */}
      <div className="contactUs_emergencyWrapper">
        <div>
          <img
            src={emergencyContact}
            alt="Emergency Contact"
            className="contactUs_emergencyImage"
          />
        </div>

        <div>
          <h2 className="contactUs_emergencyTitle">Emergency Contact</h2>
          <p className="contactUs_emergencyText">
            For urgent medical situations...
          </p>

          <div className="contactUs_emergencyBox">
            <p className="contactUs_emergencyBoxTitle">Need Help? Call Us</p>

            <div className="contactUs_emergencyPhoneRow">
              <img
                src={phoneIcon}
                alt="Phone"
                className="contactUs_emergencyPhone"
              />
              <span className="contactUs_emergencyPhoneNumber">6662 7676</span>
            </div>
          </div>
        </div>
      </div>
      {/* Button */}
      {/* <div style={{ marginTop: "20px" }}>
            <PrimaryButton
              label="Enroll a Patient"
              onClick={() => {
                navigate("/membership");
              }}
            />
          </div> */}
      <Footer />
    </div>
  );
}
